function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.68,
  cy: 7.68,
  r: 7.68,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5208 8.17535L5.99667 10.8004C5.61273 11.023 5.12 10.7535 5.12 10.3048V5.05473C5.12 4.60679 5.61202 4.3366 5.99667 4.55986L10.5208 7.18492C10.6082 7.23477 10.6808 7.30684 10.7313 7.39382C10.7818 7.48079 10.8084 7.57957 10.8084 7.68013C10.8084 7.7807 10.7818 7.87948 10.7313 7.96645C10.6808 8.05343 10.6082 8.1255 10.5208 8.17535Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "playCircleGradient",
  x1: 5.12,
  y1: 9.11766,
  x2: 11.246,
  y2: 9.12853,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8448"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3A45A"
})));

var SvgPlayCircle = function SvgPlayCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play_circle.39765ea8.svg";
export { ForwardRef as ReactComponent };